import { Select } from "antd";
import React from "react";
import { CustomLabel } from "../../Constant";
import { useIsMobile } from "../../Hooks";
import "./style.css";

export default ({ label, selectOption, onSelectClick, value, placeholder, ...props }) => {
  const isMobile = useIsMobile();
  return (
    <div className={"cls_mghunq9o_1d9070"}>
      {label && (
        <CustomLabel font_size="14">
          {label}
          <span className={"cls_mghunq9o_880525"}>*</span>
        </CustomLabel>
      )}
      <div>
        <div className={"cls_mghunq9o_132bc3"}>
          <CustomLabel font_size="14" font_weight="normal">
            {placeholder}
          </CustomLabel>
        </div>
        <Select
          className="custom-select"
          placeholder="Search to Select"
          disabled={selectOption.length === 0}
          value={value}
          {...props}
          onChange={(val) => onSelectClick(val)}>
          {selectOption.map((ei, i) => (
            <Select.Option key={ei.value} value={ei.value}>
              {ei.name}
            </Select.Option>
          ))}
        </Select>
      </div>
    </div>
  );
};
